<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: 'LessonsDashboard' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه درس ها
        </b-button
        >
      </router-link>
    </b-col>
    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>

      <name-and-link-manager
          :router-link="{ name: 'SingleLesson', params: {courseSlug:form.course_slug, slug: form.titleAndSlug.link } }"
          :label="'عنوان'"
          v-model="form.titleAndSlug"
          :validation="$v.form.titleAndSlug.name">
        <published-checkbox label="وضعیت انتشار" v-model="form.status"/>

      </name-and-link-manager>

      <b-row class="mt-5 mb-2"> عکس</b-row>
      <b-row>
        <b-col sm="3" md="3">
          <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                        :validation="$v.form.mainImage"></single-image>
        </b-col>
      </b-row>

      <b-row class="mt-5">مشخصات</b-row>

      <b-row>

        <check-box-manager :CheckBoxItems="categories" :label="'انتخاب دسته بندی'"
                           :selectedCheckBoxes="form.selectedCategory" :validation="$v.form.selectedCategory"/>


        <b-col>
          <form-group :validations="$v.form.course_id">
            <div slot-scope="{ errors, invalid }">
              <b-alert show class="overflow_div">
                <b-form-group>
                  <label>
                    دوره ها
                    <b-icon icon="arrow-clockwise" class="d-inline" @click="getCourses()"></b-icon>
                  </label>


                  <form @submit.prevent="searchMethod">
                    <input type="text" v-model="search" class="form-control">
                  </form>

                  <div class="btn btn-primary my-2 rounded-pill">{{ selectedCourseName }}</div>

                  <div v-for="course in courses">
                    <label @click="setCourseId(course)" class="mr-1" :for="`item_${course.id}`">{{
                        course.title
                      }}</label>
                  </div>
                </b-form-group>
              </b-alert>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>

        <languageBox v-model="form.language_id" :validation="$v.form.language_id"/>


      </b-row>


      <b-row>
        <form-input label="نام سکشن" v-model="form.section_name" :validation="$v.form.section_name"/>
        <published-checkbox class="mt-5" v-model="form.free" label="آیا این درس رایگان است"/>
      </b-row>


      <b-row class="mt-5">
        <form-group :validations="$v.form.abstraction" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>چکیده</label>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.abstraction" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <b-row class="mt-5">
        <form-group :validations="$v.form.body" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>متن</label>
            <b-row>
              <b-col lg="6">
                <add-iframe-to-editor @iframe-handler="iframeHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <vue2-tinymce-editor v-model="form.body" :options="defaultToolbar"></vue2-tinymce-editor>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <key-words-manager :keyWords="form.keyWords" :TableItems="form.table"/>

      <div v-if="$route.params.slug != undefined" class="my-5">

        <connect-form-to-lesson :formId="form.id" item_type="content"/>

      </div>

      <div v-if="$route.params.slug != undefined" class="my-5">

        <LessonReader/>

      </div>

      <b-row class="my-5">
        <b-col md="8" class="m-auto">
          <b-button pill type="submit" variant="purple" class="w-100"
          >تایید
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
import router from '@/router';
import {mapGetters, mapActions} from "vuex";
import category from "../product/category.vue";
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import NameAndLinkManager from "./FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "./FormItems/PublishedCheckbox.vue";
import SingleImage from "./FormItems/SingleImage.vue";
import RadioBox from "./FormItems/RadioBox.vue";
import CheckBoxManager from "./FormItems/CheckBoxManager.vue";
import FormInput from "./FormItems/FormInput.vue";
import FormTextArea from "./FormItems/FormTextArea.vue";
import KeyWordsManager from "./FormItems/KeyWordsManager.vue";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import languageBox from "../Language/LanguageBox";
import axios from "axios";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import AddIframeToEditor from "./FormItems/AddIframeToEditor";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import LessonReader from "@/plugin/components/dashboard/Content/LessonReader.vue";
import ConnectFormToLesson from "./ConnectFormToLesson.vue";


export default {
  name: "CreateContentLayout",
  components: {
    ConnectFormToLesson,
    category,
    FormGroup,
    FormErrorsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    KeyWordsManager,
    languageBox,
    Vue2TinymceEditor,
    AddIframeToEditor,
    LessonReader,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      fields: [
        {key: "name", label: "کلمه کلیدی"},
        {key: "action", label: ""},
      ],
      form: {
        titleAndSlug: {name: "", link: ""},
        mainImage: [],
        content_type: 2,
        selectedCategory: [],
        free: 0,
        section_name: null,
        status: false,
        abstraction: "",
        body: "",
        keyWords: [],
        table: [],
        mainPreview: "",
        course_id: '',
        old_course_id: '',
        course_slug: '',
        language_id: '',
      },
      defaultToolbar,
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        }
      },
      search: '',
      selectedCourseName: ''
    };
  },
  validations: {
    form: {
      titleAndSlug: {name: {required}},
      selectedCategory: {required},
      abstraction: {required},
      body: {required},
      language_id: {required},
      mainImage: {
        required: (value) => {

          return router.currentRoute.params.slug != undefined || value.length !== 0

        }
      },
      course_id: {required},
      section_name: {required},
      free: {required},

    },
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      courses: "Course/getCourses",
    }),
  },
  methods: {
    ...mapActions({
      getCourses: "Course/setCourses",
    }),
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      console.log(this.invalid());
      if (this.invalid()) {
        const form = {title: this.form.titleAndSlug.name, slug: this.form.titleAndSlug.link, ...this.form};
        this.submitFunction(form);
      }
    },
    iframeHandlerFunction(iframe) {
      this.form.body += iframe;
    },
    searchMethod() {
      this.$store.commit('Course/setFilters', {key: 'search', value: this.search})
      this.$store.dispatch("Course/setCourses");
    },
    setCourseId(course) {
      this.selectedCourseName = course.title
      this.form.course_id = course.id
    }
  },
  async mounted() {
    await this.$store.dispatch("Category/getCategories");
    await this.$store.dispatch("Course/setCourses");
    const routerslug = this.$route.params.slug;
    if (routerslug !== undefined) {
      this.form.titleAndSlug.link = routerslug;

      await this.$store.dispatch('Content/getDashboardLesson', routerslug)
          .then(async (res) => {
            res = await res.data.data
            this.form.titleAndSlug.name = res.title;
            this.form.id = res.id;
            this.form.titleAndSlug.link = res.slug;
            this.form.content_type = await res.content_type
            this.form.status = res.status ? true : false;
            this.form.mainPreview = await res.thumbnail;
            this.form.free = res.free;
            this.form.section_name = res.section_name;
            this.form.author = await res.author.id;
            this.form.description = res.description;
            this.form.abstraction = res.abstraction;
            this.form.body = res.body;

            this.form.course_id = await res.courses[0].id;
            this.form.course_slug = await res.courses[0].slug;
            this.form.old_course_id = await res.courses[0].id;
            this.selectedCourseName = await res.courses[0].title


            await res.category.forEach((category) => {
              this.form.selectedCategory.push(category)
            });


            res.keywords.forEach((keyword) => {
              this.form.keyWords.push(keyword.keyword);
              this.form.table.push({name: keyword.keyword});
            });

            let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
            document.getElementById(`language_item_${language_id}`).click();

          })
          .catch((err) => {
            console.log(err);
          });
    }
  },
  destroyed() {
    this.$store.commit('Course/setFilters', {key: 'search', value: ''})
  }
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}

.cursor_pointer {
  cursor: pointer;
}

</style>